import { render, staticRenderFns } from "./rp-attr-filter-content-note.vue?vue&type=template&id=0a60e52a"
import script from "./rp-attr-filter-content-note.vue?vue&type=script&lang=js"
export * from "./rp-attr-filter-content-note.vue?vue&type=script&lang=js"
import style0 from "./rp-attr-filter-content-note.vue?vue&type=style&index=0&id=0a60e52a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports